import { BarcodeScreenType } from '../types';

export const API_BASE_URL = process.env.REACT_APP_API_URL ?? '';
export const PR_SCREEN_URL = process.env.REACT_APP_PR_SCREEN_URL ?? '';

export const PRODUCT_CONDITION_TYPES = {
  HAS_PACKAGING: 'has_packaging',
  NO_PACKAGING: 'no_packaging',
  USABLE: 'usable',
  UNUSABLE: 'unusable',
} as const;

export const RECEIPT_GRADE_TYPES = {
  NIB: 'nib',
  NOB: 'nob',
  USABLE: 'usable',
  SALVAGE: 'salvage',
} as const;

export const BUTTON_VARIANTS = {
  PRIMARY: 'PRIMARY',
  SECONDARY: 'SECONDARY',
} as const;

export const SCREEN_TYPES = {
  LOGIN: 'LOGIN',
  APP_SELECT: 'APP_SELECT',
  SCAN_BOX: 'SCAN_BOX',
  SCAN_ITEM: 'SCAN_ITEM',
  CONFIRM_ITEM: 'CONFIRM_ITEM',
  GRADE_ITEM: 'GRADE_ITEM',
  DISPOSITION: 'DISPOSITION',
  CONFIRM_CLOSE: 'CONFIRM_CLOSE',
  RECEIVING: 'RECEIVING',
  RECEIVING_DISPOSITION: 'RECEIVING_DISPOSITION',
  GRADING_DISABLED: 'GRADING_DISABLED',
} as const;

export const AUTHENTICATION_KEYS = {
  STATION_ID: 'vsr_station_id',
} as const;

export const BARCODE_TYPES = {
  NEW_YES: '#NEW_YES#',
  NEW_NO: '#NEW_NO#',
  PACKAGING_YES: '#PACKAGING_YES#',
  PACKAGING_NO: '#PACKAGING_NO#',
  CONDITION_USABLE: '#CONDITION_USEABLE#',
  CONDITION_UNUSABLE: '#CONDITION_UNUSABLE#',
  FINISH: '#FINISH#',
  CANCEL: '#CANCEL#',
  PROBLEM: '#PROBLEM#',
  SUBMIT: '#SUBMIT#',
} as const;

export const BARCODE_SCREEN_TYPES_LIST: BarcodeScreenType[] = [
  {
    name: BARCODE_TYPES.NEW_YES,
    screen: SCREEN_TYPES.GRADE_ITEM,
  },
  {
    name: BARCODE_TYPES.NEW_NO,
    screen: SCREEN_TYPES.GRADE_ITEM,
  },
  {
    name: BARCODE_TYPES.PACKAGING_YES,
    screen: SCREEN_TYPES.GRADE_ITEM,
  },
  {
    name: BARCODE_TYPES.PACKAGING_NO,
    screen: SCREEN_TYPES.GRADE_ITEM,
  },
  {
    name: BARCODE_TYPES.CONDITION_USABLE,
    screen: SCREEN_TYPES.GRADE_ITEM,
  },
  {
    name: BARCODE_TYPES.CONDITION_UNUSABLE,
    screen: SCREEN_TYPES.GRADE_ITEM,
  },
  {
    name: BARCODE_TYPES.FINISH,
    screen: SCREEN_TYPES.SCAN_BOX,
  },
  {
    name: BARCODE_TYPES.CANCEL,
    screen: 'any',
  },
  {
    name: BARCODE_TYPES.PROBLEM,
    screen: 'any',
  },
  {
    name: BARCODE_TYPES.SUBMIT,
    screen: SCREEN_TYPES.GRADE_ITEM,
  },
];
